export const API_URL = {
    TASKS: '/tasks',
    PUNCTUALITY_DASHBOARD: '/punctualitydashboard?toc=SW',
}